// extracted by mini-css-extract-plugin
export var button = "_k-0";
export var buttonContent = "_k-d";
export var buttonGroup = "_k-b";
export var dontRestrainIconWidth = "_k-9";
export var dropdownButton = "_k-a";
export var iconContainer = "_k-8";
export var lg = "_k-4";
export var md = "_k-3";
export var pending = "_k-e";
export var sm = "_k-2";
export var spinner = "_k-c";
export var squared = "_k-7";
export var xl = "_k-5";
export var xs = "_k-1";
export var xxl = "_k-6";